import {createSlice} from '@reduxjs/toolkit';

// cat. config
import {Domain} from 'config/domain';

const createInitialState = () => ({
    // 현재 워크스페이스 정보
    ...Domain.createDefault("workspace", {flattenKeys: true}),

    // 워크스페이스 내 나의 멤버 정보
    ...Domain.createDefault("member", {flattenKeys: true}),

    // 워크스페이스 내 나의 라벨 정보
    labels: [],
    'label.MEMBER_TYPE': null,
    'label.MEMBER_POSITION': null,
    'label.MEMBER_RESPONSIBILITY': null,

    // 워크스페이스 내 내가 관리하는 인장 리스트
    seals: [],

    // 워크스페이스 내 나의 부서 정보
    departments: [],

    // 현재 선택된 부서 ID (부서가 여러 개인 멤버의 활성 부서)
    currentDepartmentId: null,

    // Client-side metadata
    clientUpdateDate: null,
});

const initialState = createInitialState();

const workspaceSlice = createSlice({
    name: 'workspace',
    initialState,
    reducers: {
        /**
         * 워크스페이스 정보 초기화
         * @param {Object} action.payload - 워크스페이스 정보 객체 (flattened keys)
         */
        initWorkspace: (state, action) => {
            return {
                ...state,
                ...action.payload,
                clientUpdateDate: new Date().toISOString()
            };
        },

        /**
         * 멤버 정보 업데이트
         * @param {Object} action.payload - 업데이트할 멤버 정보 (flattened keys)
         */
        updateMember: (state, action) => {
            return {
                ...state,
                ...action.payload,
                clientUpdateDate: new Date().toISOString()
            };
        },

        /**
         * 현재 선택된 부서 변경
         * @param {string|null} action.payload - 부서 ID
         */
        setCurrentDepartment: (state, action) => {
            state.currentDepartmentId = action.payload || null;
        },

        /**
         * 현재 선택된 부서 보정 — 소속 목록으로 재계산한 값. 저장하지 않는다.
         *
         * 보정값은 사용자의 선택이 아니라 추측한 기본값이라, 저장하면 다음 접속에
         * 사용자가 고른 값과 구분되지 않는다(저장값 유효 판정에 그대로 걸린다).
         * 저장하지 않으면 매번 현재 소속 목록에서 다시 계산된다.
         *
         * @param {string|null} action.payload - 부서 ID
         */
        syncCurrentDepartment: (state, action) => {
            state.currentDepartmentId = action.payload || null;
        },
    },
});

export const {
    initWorkspace,
    updateMember,
    setCurrentDepartment,
    syncCurrentDepartment
} = workspaceSlice.actions;

export default workspaceSlice.reducer;
